<template>
  <span class="rs-table-copyable-cell">
    <span class="rs-table-copyable-cell__content">
      <slot>{{ copyValue }}</slot>
    </span>

    <v-tooltip bottom v-if="copyValue">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          x-small
          class="rs-table-copyable-cell__button"
          color="grey darken-1"
          :aria-label="tooltip"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="handleCopy"
        >
          <v-icon small>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: "RsTableCopyableCell",
  props: {
    value: {
      default: "",
    },
    tooltip: {
      type: String,
      default: "Kopyala",
    },
    successMessage: {
      type: String,
      default: "Kopyalandı.",
    },
    errorMessage: {
      type: String,
      default: "Kopyalanamadı.",
    },
    unsupportedMessage: {
      type: String,
      default: "Tarayıcı kopyalamayı desteklemiyor.",
    },
  },
  computed: {
    copyValue() {
      if (this.value === null || this.value === undefined) {
        return "";
      }

      return String(this.value);
    },
  },
  methods: {
    handleCopy() {
      if (!navigator.clipboard) {
        this.$toast.error(this.unsupportedMessage);
        return;
      }

      navigator.clipboard
        .writeText(this.copyValue)
        .then(() => this.$toast.info(this.successMessage))
        .catch(() => this.$toast.error(this.errorMessage));
    },
  },
};
</script>

<style>
td.rs-table-copyable-cell-container {
  position: relative;
}

.rs-table-copyable-cell {
  box-sizing: border-box;
  display: block;
  padding-right: 36px;
  width: 100%;
}

.rs-table-copyable-cell__content {
  display: block;
}

td.rs-table-copyable-cell-container .rs-table-copyable-cell__button {
  bottom: 8px !important;
  position: absolute !important;
  right: 8px !important;
}
</style>
